export * from './PageNewMaterialDetails'
